import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookB4 } from './taf-book-b4-list';

import { HttpHelper } from '../../../shared/http-helper';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookB4Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookB4Url = ` http://localhost:55706/api/systemmanagement/TAFBookB4`;
    private _tafBookB4Url = `api/systemmanagement/TAFBookB4`;

    constructor(private httpHelper: HttpHelper) { }

    getTAFBookB4(): Observable<ITAFBookB4> {
         return this.httpHelper.get(`${this._tafBookB4Url}`)
             //.map((response: Response) => <ITAFBookB4> response.json())
             //.do(httpHelper => console.log('ITafBookB4: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b4/taf-book-b4.service.ts
 **/